module.exports = "/fonts/trialProofer-iconPack.svg?911d0bfee8b3c87fffda820afda976a5";